module.exports = __webpack_public_path__ + "img/fx-b.4386709a.png";